import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class FormsService {

  public _EnableDisabledList = null;

  EnableDisabledList$: Observable<any>;

  private EnableDisabledListSubject: Subject<any>;

  constructor() {
    this.EnableDisabledListSubject = new Subject<any>();
    this.EnableDisabledList$ = this.EnableDisabledListSubject.asObservable();
  }

  setEnableDisabledList(value) {
    this._EnableDisabledList = value;
    this.EnableDisabledListSubject.next(value);
  }

  ElementEnabled(elementName: string) {
    if (this._EnableDisabledList != null && this.globalSearch(this._EnableDisabledList, elementName.toUpperCase()) != false) {
      return this.globalSearch(this._EnableDisabledList, elementName.toUpperCase()).enable;
    } else {
      return false;
    }
  }

  ElementHidden(elementName: string) {
    if (this._EnableDisabledList != null && this.globalSearch(this._EnableDisabledList, elementName.toUpperCase()) != false) {
      return this.globalSearch(this._EnableDisabledList, elementName.toUpperCase()).hidden;
    } else {
      return false;
    }
  }

  //Funcion to find url by name
  private globalSearch(obj, value) {
    for (var p in obj) {
      if (obj[p] != null && obj[p].formName != null && obj[p].formName.toUpperCase() == value) {
        return (obj[p]);
      }
    }
    return false;
  }

}
